import React, { useEffect, useState } from "react";
import styles from "./communication.module.css";
import CustomTable from "../../../../../../common/custom-table/custom-table";
import { fetchStudentCommunications } from "../../../../../../services/student";

const Communication = ({ studentID }) => {
  const [loading, setLoading] = useState(false);
  const [communicationList, setCommunicationList] = useState([]);

  useEffect(() => {
    studentID && getStudentCommunications();
  }, [studentID]);

  const getStudentCommunications = async () => {
    try {
      setLoading(true);
      const response = await fetchStudentCommunications(studentID);
      if (response?.data) {
        setCommunicationList(response?.data?.data);
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log("error", error);
    }
  };

  const columns = [
    {
      title: "Date",
      dataIndex: "date",
      key: "date",
      render: (value) => value || "-",
    },
    {
      title: "Message",
      dataIndex: "message",
      key: "message",
      render: (value) => value || "-",
    },
    {
      title: "From",
      dataIndex: "from",
      key: "from",
      render: (value) => value || "-",
    },
  ];

  return (
    <div className={styles.communication}>
      <CustomTable
        columns={columns}
        dataSource={communicationList}
        loading={loading}
        showMoreIcon={false}
        pagination={false}
      />
    </div>
  );
};
export default Communication;
